import React, { useState, useEffect, useCallback } from 'react'
import { Pagination, Carousel, Image, Popover } from 'antd';
import { useNavigate } from 'react-router-dom';
import { request } from "@/utils/request"
import './index.less'
import Detail from "@/pages/Detail";
import NavigationBar from "@/components/NavigationBar";
import Config from "@/config/config";
import search from '@/assets/search.png'
import eat from '@/assets/eat.png'
import address from '@/assets/address.png'
import noSearch from '@/assets/noSearch.png'

import { Input } from 'antd';

import {
    DeleteOutlined,
    DownOutlined,
    SearchOutlined,
    UpOutlined
} from '@ant-design/icons';


export default function Main() {
    const [recommend, setRecommend] = useState([])
    const [banner, setBanner] = useState([])
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(12)
    const [total, setTotal] = useState(0)

    const [selectedItem, setSelectedItem] = useState(null);
    const [regionList, setRegionList] = useState([]);
    const [regionInfo, setRegionInfo] = useState([]);
    const [cateList, setCateList] = useState([]);
    const [currentType, setCurrentType] = useState(0);
    const [currentCity, setCurrentCity] = useState((JSON.parse(sessionStorage.getItem('sy'))?.currentCity)||0);
    const [currentRegion, setCurrentregion] = useState(JSON.parse(sessionStorage.getItem('sy'))?.currentRegion || 0);
    const [params, setParams] = useState(JSON.parse(sessionStorage.getItem('sy'))?.params || {
        region_id: '',
        category_id: '',
    })
    const [openSet, setOpenSet] = useState({
        region: false,
        type: false,
    })
    const [selectVal, setSelectVal] = useState(JSON.parse(sessionStorage.getItem('sy'))?.selectVal || {})
    const [searchHistory, setSearchHistory] = useState(JSON.parse(localStorage.getItem('syHis')) || []);
    const [lastRegionInfo, setLastRegionInfo] = useState([]);
    const [currentLastregion, setCurrentLastregion] = useState(JSON.parse(sessionStorage.getItem('sy'))?.currentLastregion || 0);
    const fetchData = async (page, perPage, name = '', first_region_id = '', region_id = '', category_id = '') => {
        try {
            let url = '/restaurant/recommend-list' + `?page=${page}&per-page=${perPage}`;
            if (name) {
                url += "&name=" + name
            }
            if (first_region_id) {
                url += "&first_region_id=" + first_region_id
            }
            if (region_id) {
                url += "&region_id=" + region_id
            }
            if (category_id) {
                url += "&category_id=" + category_id
            }
            const response = await request.get(url);
            let data = response.data
            setRecommend(data)
            setTotal(response._meta.totalCount)
            sessionStorage.setItem("sy", JSON.stringify({
                selectVal,
                params,
                currentCity,
                currentRegion,
                currentLastregion
            }))
            if (name) {
                // 过滤掉 searchHistory 中已存在的搜索词，然后将新的搜索词添加到数组开头
                const newSearchHistory = [name, ...searchHistory.filter(item => item !== name)];
                setSearchHistory(newSearchHistory);
                localStorage.setItem('syHis', JSON.stringify(newSearchHistory));
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }



    };
    const fetchBanner = async () => {
        const response = await request.get('/banner/list?position=pc-Top&platform=1');
        setBanner(response.data || [])
    };
    useEffect(() => {
        getRegionList()
        getCateList()

        fetchBanner()
    }, [])
    const getRegionList = async () => {
        const reponse = await request.get('restaurant/region-list?page=1&per-page=100', {});
        reponse.data.unshift({
            children: [],
            id: "",
            name: "全部",
        })
        let temp = reponse.data
        temp = temp.map((v, i) => {
            let child = v.children;
            child.first_region_id = v.id;
            if (i > 0) {
                child?.unshift({
                    id: '',
                    name: `全${v.name}`,
                    first_region_id: v.id,
                    children: [] // 新增一级的空数组
                });
            }
            // 处理新增的一级
            child = child.map((subV, subI) => {
                if (subI > 0) {
                    subV.children?.unshift({
                        id: '',
                        name: `全${subV.name}`,
                        first_region_id: subV.id
                    });
                }
                return subV;
            });
            return v;
        });
        setRegionList(temp)
        setRegionInfo(temp[0].children)
        setLastRegionInfo(temp[0]?.children[0]?.children);
    }
    useEffect(() => {
        sessionStorage.setItem("mbx", "main")
        console.log(JSON.parse(sessionStorage.getItem('sy')),'000')
        setCurrentCity(JSON.parse(sessionStorage.getItem('sy'))?.currentCity)
        setCurrentregion(JSON.parse(sessionStorage.getItem('sy'))?.currentRegion)
        setCurrentLastregion(JSON.parse(sessionStorage.getItem('sy'))?.currentLastregion)
        fetchData(page, perPage, params.name, params.first_region_id, params.region_id, params.category_id);
    }, [])

    const navigate = useNavigate()

    const doSearch = (val) => {
        console.log(val)
        // fetchData(0,perPage,val)
        navigate('/search?name=' + val)

    }


    const pageChange = (e, v) => {
        console.log(e, v);
        setPage(e)
        setPerPage(v)
        fetchData(e, v);
    }
    const toNotice = (item) => {

        if (item.type === 0) {
            navigate('/detail?id=' + item.bind_id)
        }

    }
    const calculateTextAligin = (idx) => {
        let res = idx % 4;
        if (res === 0) {
            return "left"
        }
        if (res >= 1 && res <= 2) {
            return "center"
        }
        if (res === 3) {
            return "right"
        }
    }
    const changeCity = (val, index) => {
        setPage(1)
        selectVal.region = val.name
        setSelectVal({ ...selectVal })
        setCurrentCity(index)
        setCurrentregion(0)
        setRegionInfo(regionList[index]?.children)
        setLastRegionInfo([])
        if (index == 0) {
            setOpenSet({ ...openSet })
        }
        openSet.region = false
        params.first_region_id = val.id
        params.region_id = ''
        setParams({ ...params })
        fetchData(1, perPage, params.name, val.id, '',params.category_id);
    }
    const changeRegion = (val, index) => {
        setPage(1)
        console.log(val, index)
        selectVal.region = val.name
        setSelectVal({ ...selectVal })
        setCurrentLastregion(0)
        setLastRegionInfo(val?.children)
        setCurrentregion(index)
        params.region_id = val.id
        setParams({ ...params })
        fetchData(1, perPage, params.name, params.first_region_id, val.id);
        openSet.region = false
        setOpenSet({ ...openSet })
    }
    const changeLastRegion = (val, index) => {
        console.log(lastRegionInfo, val, 'laa')
        selectVal.region = val.name
        setSelectVal({ ...selectVal })
        setCurrentLastregion(index)
        openSet.region = false
        setOpenSet({ ...openSet })
        if (val.first_region_id) {
            params.region_id = val.first_region_id
        }
        params.region_id = val.id
        setParams({ ...params })
        fetchData(1, perPage, params.name, '', val.id || val.first_region_id);
    }
    const changeType = (val, index) => {
        setPage(1)
        selectVal.type = val.name
        setSelectVal({ ...selectVal })
        setCurrentType(index)
        params.category_id = val.id
        setParams({ ...params })
        openSet.type = false
        setOpenSet({ ...openSet })
        fetchData(1, perPage, params.name, params.first_region_id, params.region_id, val.id);
    }
    const getCateList = async () => {
        // restaurant/category-list
        const reponse = await request.get('restaurant/category-list?page=1&per-page=100', {});
        reponse.data.unshift({
            id: "",
            name: "全部"
        })
        reponse.data?.map((v, i) => {
            if (v.id == (JSON.parse(sessionStorage.getItem('sy')))?.params?.category_id) {
                console.log('fansule')
               setCurrentType(i)
            }
        })
        setCateList(reponse.data)
    }
    const resetSearchHistory = () => {
        localStorage.removeItem('ctHis')
        setSearchHistory([])
    }
    const handleHistorySearch = (item) => {
        params.name = item
        setParams({ ...params })
        fetchData(page, perPage, item, params.first_region_id, params.region_id, params.category_id, params.honor_ids, params.tag_ids);
    }
    const SearchHistoryComp = () => {
        return (
            <>
                <div className="search-history-box">
                    <div className="search-history-box-item-head">
                        <div className="search-history-box-item-head-left">历史记录</div>
                        <div className="search-history-box-item-head-right"
                            onClick={resetSearchHistory}
                        >
                            <DeleteOutlined /></div>
                    </div>
                    <div className="search-history-box-content">
                        {searchHistory.map((item) => {
                            return (
                                <div className="search-history-list-item" onClick={() => {
                                    handleHistorySearch(item)
                                }}>
                                    <div className="search-history-list-item-icon">
                                        <SearchOutlined />
                                    </div>
                                    <span className="search-history-item-text">
                                        {item}
                                    </span>
                                </div>
                            )
                        })}
                    </div>

                </div>
            </>
        )
    }
    // 定义一个变量用于存储定时器 ID
    let timeoutId = null;
    const nameSearch = (e) => {
        setPage(1)
        e.stopPropagation();
        params.name = e.target.value
        setParams({ ...params })
        // 清除之前的定时器
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            fetchData(1, perPage, e.target.value, params.first_region_id, params.region_id, params.category_id);
        }, 1000);
    }

    return (
        <div className='main-content' onClick={() => {
            console.log('lijiao')
            openSet.region = false
            openSet.type = false
            setOpenSet({ ...openSet })
        }}>
            <NavigationBar showNavRight={true} showNavTabs={true} showSearch={true} onSearchChange={doSearch}></NavigationBar>
            <div className="swiper" >
                <Carousel dots={{ className: "dots-style" }}
                    autoplay
                >
                    {banner && banner.map((item) => {
                        return (
                            <div >
                                <img width="100%" height={320} onClick={() => { toNotice(item) }} src={Config.imgPrefix + item.img_url} style={{ objectFit: "cover" }} />
                            </div>
                        )
                    })}
                </Carousel>
            </div>
            <div className="heart" >
                <div className="search-content">
                    <div className="search-title">筛选餐厅</div>
                    <div className='search-tool'>
                        <Popover placement="bottom" content={SearchHistoryComp} title=""
                            style={{ borderRadius: "8px" }}>
                            <div className='search-input'>
                                <img src={search} alt="" className='searchIcon' />
                                <input value={params.name} placeholder="搜索餐厅名称" onInput={(e) => nameSearch(e)} />
                            </div>
                        </Popover>
                        <div className='search-select'>
                            <div className='select-moudle-main'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openSet.region = !openSet.region
                                    openSet.type = false
                                    setOpenSet({ ...openSet })
                                }}>
                                <div className='select-item'>
                                    <div className='select-label'>
                                        <img src={address} alt="" className='icon' />
                                        <div className='select-type'>{selectVal.region || '区域'}</div>
                                    </div>

                                    {
                                        openSet.region ? <UpOutlined /> : <DownOutlined />
                                    }
                                </div>
                                {
                                    openSet.region && <div className='select-mask-region'>
                                        <div className='left'>
                                            {
                                                regionList?.map((v, i) => {
                                                    return <div
                                                        onClick={() => { changeCity(v, i) }}
                                                        className={`city-item ${currentCity == i ? 'active' : ''}`}
                                                    >{v.name}</div>
                                                })
                                            }
                                        </div>
                                        <div className='middle'>
                                            <div >
                                                {
                                                    regionInfo?.map((v, i) => {
                                                        return <div
                                                            className={`city-item ${currentRegion == i ? 'active' : ''}`}
                                                            onClick={() => { changeRegion(v, i) }}
                                                        >{v.name}</div>
                                                    })
                                                }</div>
                                        </div>
                                        <div className='right'>
                                            <div >{
                                                lastRegionInfo?.map((v, i) => {
                                                    return <div
                                                        className={`region-item ${currentLastregion == i ? 'active' : ''}`}
                                                        onClick={() => { changeLastRegion(v, i) }}
                                                    >{v.name}</div>
                                                })
                                            }</div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className='select-moudle-main'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openSet.region = false
                                    openSet.type = !openSet.type
                                    setOpenSet({ ...openSet })
                                }}
                            >
                                <div className='select-item'>
                                    <div className='select-label'>
                                        <img src={eat} alt="" className='icon' />
                                        <div className='select-type'>{selectVal.type || '餐厅类型'}</div>
                                    </div>
                                    {
                                        openSet.type ? <UpOutlined /> : <DownOutlined />
                                    }
                                </div>
                                {
                                    openSet.type && <div className='select-mask-type' onBlur={() => {
                                        openSet.type = false
                                        setOpenSet({ ...openSet })
                                    }}>
                                        <div className='all'>
                                            <div >{
                                                cateList?.map((v, i) => {
                                                    return <div
                                                        className={`all-item ${currentType == i ? 'active' : ''}`}
                                                        onClick={() => { changeType(v, i) }}
                                                    >{v.name}</div>
                                                })
                                            }</div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <div className="main-title">推荐餐厅</div>

                <div className='item-content'>
                    {
                        recommend?.length > 0 ? <>
                            {
                                recommend.map((item, idx) => {
                                    return (
                                        // 如果你想在 style 属性中添加更多判断，可以使用三元运算符或者对象合并的方式。以下是一个修改后的代码示例，它根据 idx 是否为 4 的倍数来设置 marginRight 属性：
                                        <div key={item.id} className='main-items'>
                                            <div className="picture" style={{ textAlign: calculateTextAligin(idx) }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate('/detail?id=' + item.id)
                                                }}
                                            >{item.prize_enable == 1 &&
                                                <div className="prize-icon">抽选</div>}
                                                <Image
                                                    preview={false}
                                                    src={Config.imgPrefix + item.cover[0] || 'error'}
                                                    className="cover"
                                                    fallback="data:image/png;base64,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"
                                                />
                                            </div>
                                            <div className="name">{item.name}</div>
                                            <div className="name_en">{item.name_en}</div>
                                            <div className="city" style={{ fontSize: "12px", display: 'flex', alignItems: 'center', }}>
                                                <div style={{ marginRight: '10px' }}>{item.category_names.join('·')}</div>
                                                {
                                                    item.region && <div>{item.region}</div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </> :
                            <div className='no-data'>
                                <img src={noSearch} alt="" srcset="" className='searchIcon' />
                                <div className='no-data-tip'>没有搜索结果</div>
                            </div>
                    }
                    {selectedItem && <Detail item={selectedItem} />}
                </div>
                <div className="pagination-box">
                    <Pagination
                        className='main-pagination'
                        total={total}
                        pageSize={perPage}
                        pageSizeOptions={[12, 24, 36, 48]}
                        onChange={pageChange}
                        showQuickJumper
                        showTotal={(total) => `共${total}条`}
                        current={page}
                    />
                </div>
            </div>

        </div>
    )
}